export enum ButtonTypes {
  primary = "primary",
  success = "success",
  warning = "warning"
}

export type ButtonColor = {
  [key in ButtonTypes]: string;
};

export enum LocalStorageKeys {
  LastChanged = "lastChanged",
  Token = "token",
  UserProfile = "f360.user.profile",
  userRules = "f360.user.roles",
  menuToggle = "menuToggle-f360"
}

export enum F360Product {
  Admin = "admin",
  Contabil = "contabil",
  Indicadores = "Indicadores",
  Financas = "financas",
  Solicitacao = "solicitacao",
  FinancasNewHorizons = "financas/v2",
  Antecipa = "antecipa",
  MinhaGestao = "minhaGestao",
  Gestor360 = "Gestor360"
}

export interface IMenuRouterConfig {
  product: F360Product;
  routeName?: string;
  hasSubRoutes?: boolean;
}

export interface IF360Sidebar {
  menuLabel: string;
  children?: IF360Sidebar[];
  //icon?: DefineComponent;
  icon?: string;
  img?: string;
  product?: F360Product;
  page?: string;
  validator?: boolean[];
  routerConfig?: IMenuRouterConfig | (() => Promise<string | void>);
  roles?: FinancasUserRoles[];
  isGrouped?: boolean;
  isInfo?: boolean;
  isItem?: boolean;
  customClass?: string;
  showBagde?: boolean;
  hideOnCielo?: boolean;
}

export interface IButtonProps {
  type: string;
}

export interface IOptions {
  value: string;
  label: string;
}

export type DatePickerRange = [start: string | null, end: string | null];

export const columnFilterProvider = Symbol("f360ColumnFilter");

export enum ETypeChart {
  line = "line",
  area = "area",
  bar = "bar",
  radar = "radar",
  histogram = "histogram",
  pie = "pie",
  donut = "donut",
  radialBar = "radialBar",
  scatter = "scatter",
  bubble = "bubble",
  heatmap = "heatmap",
  candlestick = "candlestick"
}

export enum EEventsChart {
  changeTypeChart = "changeTypeChart",
  chartUpdate = "chartUpdate",
  clearFilter = "clearFilter"
}

export enum EEventsShortcut {
  shortcutUpdate = "shortcutUpdate",
  shortcutCustom = "shortcutCustom",
  notifyChange = "notifyChange",
  updateShortcutFilter = "updateShortcutFilter"
}

export enum EWidgetType {
  alert = "alert",
  chart = "chart",
  card = "card",
  panel = "panel"
}

export interface ISelect<T = string> {
  label: string;
  value: T;
}

export interface IF360Sidebar {
  menuLabel: string;
  children?: IF360Sidebar[];
  icon?: string;
}

export interface IButtonProps {
  type: string;
}

export type Required<T> = {
  [P in keyof T]-?: T[P];
};

export enum EDateFormat {
  day = "DD/MM/YYYY",
  month = "DD/MM",
  longMonth = "MMM/YYYY",
  monthYear = "MM/YYYY",
  start = "Início",
  end = "Fim",
  dateParmFormat = "YYYY-MM-DD 00:00:00",
  dayHour = "DD/MM/YYYY - HH:mm",
  shortYear = "DD/MM/YY"
}

export enum EBandeiras {
  defaultImg = 2222,
  bancoBrasil = 1,
  itau = 341,
  santander = 33,
  bradesco = 237,
  bradesco2 = 394
}

export interface IDictionary<T> {
  [index: string]: T;
}

export type RequiredNotNull<T> = {
  [P in keyof T]: NonNullable<T[P]>;
};

export enum EFeatureFlags {
  divergenciaAluguelPOS = "DivergenciaAluguelPOS",
  MinhaGestao = "MinhaGestao",
  whatsapp = "WhatsappDoGestor",
  NovaNotificacao = "NovaNotificacao",
  NovaFaq = "NovaFaq",
  AutoCredenciamentoStone = "AutoCredenciamentoStone",
  telaAntecipa = "Antecipa",
  AgendamentoNovaFAQ = "AgendamentoNovaFAQ",
  NovaTelaRegraDeRateio = "NovaTelaRegraDeRateio",
  NovaTelaRelatorio = "NovaTelaRelatorio",
  CampanhaBannerBwa = "CampanhaBannerBwa",
  NovaTelaUsuarios = "NovaTelaUsuarios",
  BannerAntigaDashboard = "BannerAntigaDashboard",
  TourMinhaGestao = "TourMinhaGestao",
  NovaTelaPlanoDeConta = "NovaTelaPlanoDeConta",
  BannerAvisoFinanceiro = "BannerAvisoFinanceiro"
}

export interface IFranqueadores {
  ExistemPendencias: boolean;
  Franqueador: {
    _id: string;
    Value: {
      Annotations: string[];
      Ativo: boolean;
      CodigoCliente: number;
      HabilitaBloqueioDeRegistrosAprovados: boolean;
      Id: number;
      IsPremium: boolean;
      MarcasDaFranquia: number[];
      Nome: string;
      Perfil: number;
      Portofino: {
        TipoDeExclusaoDoCliente: number;
        TipoDeMarcaDoCliente: number;
      };
      QuantidadeMaximaDeEmpresas: number;
      Timestamp: string;
      TipoDePerfilComCodigoCliente: string;
      UpdatedAt: string;
      ZendeskId: number;
      _id: string;
    };
  };
  Marca: 39;
  MarcaTexto: string;
  PlanosDoFranqueadoPendentes: number;
}

export interface IUserProfile {
  Ambiente?: string;
  _id: string | null;
  GrupoId: string | null;
  Nome: string | null;
  Email: string | null;
  PaginaInicial: string | null;
  Grupo: string | null;
  Perfil: number | null;
  Franqueadores?: IFranqueadores[] | null;
  TemPerformance: boolean | null;
  TemContabil: boolean | null;
  NovoContabilAtivoOculto: boolean | null;
  TemNovoContabil: boolean | null;
  ContabilLiberado: boolean | null;
  PreferenciasLiberadas: boolean | null;
  CodigoCliente: string | null;
  PerfilAdm: boolean | null;
  Features?: string[] | null;
  Marcas: string[] | null;
  MarcasEnum?: number[] | null;
  Modulo: number;
  CredenciamentoLiberado: boolean;
  QtdEmpresa?: number;
  AntecipaLiberado: boolean | null;
  IsRepresentanteLegal: boolean | null;
  RepresentantesLegais: string[] | null;
}

export enum DITypes {
  DEV = "dev",
  FINANCAS_AUTH = "financas_auth",
  FINANCAS_RESOURCES = "financas_resources",
  EVENT = "event",
  INTERCEPTOR = "http_interceptor",
  PRODUCT = "product_client",
  CONTABIL_HTTP_CLIENT = "contabil_http_client",
  FINANCAS_HTTP_CLIENT = "financas_http_client",
  HORIZONS_HTTP_CLIENT = "horizons_http_client",
  INDICADORES_HTTP_CLIENT = "indicadores_http_client",
  WEBSOCKET_CLIENT = "websocket_client",
  GITHUB_HTTP_CLIENT = "github_http_client",
  STORAGE = "storage",
  DATE = "date",
  DATE_UTILS = "date_utils",
  PESQUISA_GATEWAY = "indicadores_pesquisa_gateway",
  CURRENCY = "CURRENCY",
  HTTP_MIDDLEWARE_INTERCERPT = "HttpMiddlewareIntercept",
  UTILITY = "UTILITY",
  GITHUB_GATEWAY = "GITHUB_HTTP_CLIENT",
  DOWNLOAD_ON_BROWSER = "DOWNLOAD_ON_BROWSER",
  DOWNLOAD_PDF = "DOWNLOAD_PDF",
  DOWNLOAD_ZIP = "DOWNLOAD_ZIP",
  DOWNLOAD_FILE = "DOWNLOAD_FILE",
  DOWNLOAD_PNG = "DOWNLOAD_PNG",
  DOWNLOAD_PFX = "DOWNLOAD_PFX",

  // CIELO = "CIELO",
  // ACESSO_CONTABIL = "ACESSO_CONTABIL",
  // PRE_CADASTRO = "PRE_CADASTRO"
  NOTIFICATION = "NOTIFICATION",
  PESQUISA_NPS_GATEWAY = "PESQUISA_NPS_GATEWAY",
  PESQUISA_NPS_HANDLER = "PESQUISA_NPS_HANDLER",
  ADICIONAR_EMPRESA_GATEWAY = "ADICIONAR_EMPRESA_GATEWAY",

  USER_LOGOUT = "USER_LOGOUT",
  USER_WHATSAPP = "USER_WHATSAPP",
  USER_WHATSAPP_V2 = "USER_WHATSAPP_V2",

  GAMEFICACAO_DASHBOARD = "GAMEFICACAO_DASHBOARD",

  SLACK_MENSAGEM = "SLACK_MENSAGEM",

  FEED_NOVIDADES = "FEED_NOVIDADES",
  HANDLE_MENSAGENS = "HANDLE_MENSAGENS",
  HANDLE_NOVIDADES = "HANDLE_NOVIDADES",
  FEED_DE_NOVIDADES = "FEED_DE_NOVIDADES",

  HANDLE_TAKESCREENSHOT = "HANDLE_TAKESCREENSHOT",

  FINANCAS_FEATURES = "FINANCAS_FEATURES",

  HORIZONS_GATEWAY = "HORIZONS_GATEWAY"
}

export enum DIDownloadTypes {
  DOWNLOAD_PDF = "DOWNLOAD_PDF",
  DOWNLOAD_ZIP = "DOWNLOAD_ZIP",
  DOWNLOAD_ON_BROWSER = "DOWNLOAD_ON_BROWSER"
}

export enum DIMiddlewares {
  FILE_NAME_HEADER = "FILE_NAME_HEADER"
}

export enum DIValidators {
  CADIS = "cadis_validator",
  CIELO = "CIELO",
  ACESSO_CONTABIL = "ACESSO_CONTABIL",
  CONTABIL_LIBERADO = "CONTABIL_LIBERADO",
  TESTES_GERAIS = "TESTES_GERAIS",
  CLI_VALIDATOR = "CLI_VALIDATOR",
  COMERCIAL = "COMERCIAL",
  FEATURE_FLAGS = "FEATURE_FLAGS",
  CLOSER = "CLOSER",
  SYS_ADMIN = "SYS_ADMIN",
  SHOW_EDUCA = "SHOW_EDUCA",
  USUARIO_ADMIN = "USUARIO_ADMIN",
  USUARIO_SYS_ADMIN = "USUARIO_SYS_ADMIN",
  ACESSO_ANTECIPA = "ACESSO_ANTECIPA"
}

export enum DIMixins {
  USER_PROFILE_STORAGE = "USER_PROFILE_STORAGE",
  LOCAL_FILTERS_STORE = "LOCAL_FILTERS_STORE",
  PREFERENCES_STORE = "PREFERENCES_STORE"
}

export enum FinancasUserRoles {
  Admin = "sysAdmin",
  Dashboard = "DashBoard.Index",
  FechamentoDeCaixa = "FechamentoDeCaixa.Index",
  Conciliacao = "Conciliacao.Index",
  Receita = "Receita.Index",
  Despesa = "Despesa.Index",
  Nfe = "NFe.Index",
  PlanoOrcamentario = "PlanoOrcamentario.Index",
  FluxoDeCaixa = "FluxoDeCaixa.Index",
  ContasMovimento = "ContasMovimento.Index",
  DRE = "DRE.Index",
  Diagnostico = "Diagnostico.Index",
  Arquivo = "Arquivo.Index",
  CanalContador = "CanalContador.Index",
  MinhaGestao = "MinhaGestao.Index",
  Store = "Store.Index"
}

export enum EFinancasModulos {
  "COMPLETO" = "COMPLETO",
  "CIELO_LIGHT" = "CIELO_LIGHT",
  "CIELO_FIT" = "CIELO_FIT"
}

export enum EModulos {
  Completo = 0,
  Despesas_Receitas = 1,
  Fit = 2,
  Light = 3
}

export enum EPluggyTypes {
  PLUGGY_CONNECTOR = "PLUGGY_CONNECTOR",
  PLUGGY_GATEWAY = "PLUGGY_GATEWAY",
  CRIAR_WEBSERVICE = "CRIAR_WEBSERVICE",
  HANDLE_WEBSERVICE = "HANDLE_WEBSERVICE",
  CONTA_VALIDATOR = "CONTA_VALIDATOR"
}

export type IFinancasCentroDeCusto = {
  _id: string;
  nome: string;
  customer?: {
    _id: string;
  };
  codigoExterno?: string | null;
  centroDeCustoPadrao?: boolean | null;
  franqueadoresDisponiveis?: string | null;
  mostrarOpcaoDeFranqueadores?: boolean | null;
  nomesDosFranqueadoresDisponiveis?: string | null;
  dataBaseName?: string | null;
  timestamp?: string;
  updatedAt?: string;
};

export type IDefaultHttpFinancasResponse<T> = {
  Ok: boolean;
  Result: T;
};
